
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
	import RadioButton from '@/components/radio-button.vue'
  import Dialog from '@/components/dialog.vue';
  import {
    commssioncommssionRecord,
    commssionmemberCommission,
    membermemberDetail,
    commssionmemberCommissionTransfer
  } from "@/api/finance"
  import {
    nextDay,
    getSearchDate
  } from "@/utils"
  import {
    defaultHeader
  } from "@/utils/config"
  import {
    memberAuthInfoByPhone
  } from "@/api/agent_user"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
      RadioButton,
      'slz-dialog': Dialog,
    }
  })

  export default class ProductList extends Vue {
    private defaultHeader = defaultHeader
    private radioList = [
      {value:0,label:'购物金管理'},
      {value:1,label:'购物金明细'},
    ]
    private radioType= 0
    private keywords = ''
    private grade = null
    private gradelist = [
      {
				label: '全部',
				value: null
			},{
				label: 'SVIC',
				value: 1
			}, {
				label: 'VIC',
				value: 2
			},  {
				label: 'VIP',
				value: 3
			}, 
      // {
			// 	label: '客户',
			// 	value: 0
			// }
    ]
    private keywords1 = ''
    private type1 = null
    private typelist1 = [
      {value:null,label:'全部'},
      {value:8,label:'下单'},
      {value:12,label:'取消订单'},
      {value:10,label:'发货前退款'},
      {value:11,label:'退货退款'},
      {value:9,label:'仅退款'},
      {value:2,label:'提现成功'},
      {value:1,label:'发起提现'},
      {value:3,label:'提现失败'},
    ]
    private filterTime1 = [getSearchDate(1,false)[0],getSearchDate(2,false)[0]].join('/')
    private result:any = {}
    private tablelist:any = []
    private tablelist1:any = []
    private tableloading = false
    private pageSize = 10
    private pageNo = 1
    private total = 0
    private rowmsg:any = {}
    private moveShow = false
    private movemsg:any = {
      WaitDrawBalance:'',
      movetype:1,
      movephone:'',
      moveremark:'',
      movename:'',
      moveurl:'',
      movegrade:'',
      movegradeValue:'',
      moveId:''
    }
    private membermsg:any = {}
    private moveloading = false
    private complete = false
    private moveSuc = false

    private mounted () {
      this.changePage(1)
    }


    private async confirmMove(){
      if(this.membermsg.AuthState!=2){
        if(!this.movemsg.moveId){
          this.$message.error('请选择转移对象')
          return 
        }
      }
      if(!this.movemsg.moveremark){
        this.$message.error('请输入备注信息')
        return 
      }
      try{
        this.moveloading = true
        let data:any = {
          TransferMemberId:this.rowmsg.Id,
          Remark:this.movemsg.moveremark,
          TransferMoney:this.movemsg.WaitDrawBalance
        }
        if(this.membermsg.AuthState==2){
          data.MemberId = this.movemsg.movetype==1?this.membermsg.SuperId:this.membermsg.RecommendId
        }else{
          data.MemberId = this.movemsg.moveId
        }
        let res = await commssionmemberCommissionTransfer(data)
        if(res.IsSuccess){
          this.moveSuc = true
          this.moveShow = false
          this.gettablelist()
        }
      }finally{
        this.moveloading = false
      }
    }
    private async searchper(){
      try{
        let res = await memberAuthInfoByPhone({
          Phone:this.movemsg.movephone
        })
        if(res.IsSuccess){
          this.movemsg.moveId = res.Result.Id
          this.movemsg.movename = res.Result.Name
          this.movemsg.movegrade = res.Result.RoleGrade
          this.movemsg.movegradeValue = res.Result.RoleGradeValue
          this.movemsg.moveurl = res.Result.WxHeadUrl
        }
      }finally{
        this.complete = true
      }
    }
    private async transfer(row){
      this.rowmsg = row
      this.complete = false
      this.moveShow = true
      try{
        this.moveloading = true
        let res = await membermemberDetail({
          MemberId:row.Id
        })
        if(res.IsSuccess){
          this.membermsg = res.Result
          this.movemsg = {
            WaitDrawBalance:row.WaitDrawBalance,
            movetype:1,
            movephone:'',
            moveremark:'',
            movename:'',
            moveurl:'',
            movegrade:''
          }
        }
      }finally{
        this.moveloading = false
      }
    }
    private changePage(e){
      this.pageNo = e
      if(this.radioType == 0){
        this.gettablelist()
      }else{
        this.gettablelist1()
      }
    }
    private changeradiotype(e){
      this.pageNo = 1
      if(e==0){
        this.gettablelist()
      }else{
        this.gettablelist1()
      }
    }
    private doSearch(){
      this.changePage(1)
    }
    private clearSearch(){
      if(this.radioType==0){
        this.keywords = ''
        this.grade = null
        this.gettablelist()
      }else{
        this.keywords1 = ''
        this.type1 = null
        this.filterTime1 = [getSearchDate(1,false)[0],getSearchDate(2,false)[0]].join('/')
        this.gettablelist1()
      }
    }
    private exportlist(){
      let url = location.origin
      if(this.radioType==0){
        url += '/pc/commssion/memberCommissionExport'
        url += '?Keywords=' + encodeURIComponent(this.keywords)
        url += '&RoleGrade=' + (this.grade||'')
      }else{
        url += '/pc/commssion/commssionRecordExport'
        url += '?Keywords=' + encodeURIComponent(this.keywords1)
        url += '&RecordType=' + (this.type1||'')
        if (this.filterTime1){
					var splitList = this.filterTime1.split('/');
					url += '&StartTime=' + splitList[0];
          url += '&EndTime=' + nextDay(splitList[1],1)
				}
      }
      window.open(url)
    }
    private async gettablelist(){
      this.tableloading = true
      try{
        let res = await commssionmemberCommission({
          Keywords:this.keywords,
          RoleGrade:this.grade,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.result = res.Result
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private async gettablelist1(){
      this.tableloading = true
      try{
        let data:any = {
          Keywords:this.keywords1,
          RecordType :this.type1,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        if (this.filterTime1){
					var splitList = this.filterTime1.split('/');
					data.StartTime = splitList[0];
					data.EndTime = nextDay(splitList[1],1);
				}
        let res = await commssioncommssionRecord(data)
        if(res.IsSuccess){
          this.tablelist1 = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
